import ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

import IdentityProviders from 'workspaces/launcher/data/IdentityProviders';

type OnFetchSuccess = (identityProviders: IdentityProviders) => void;
type OnFetchError = (error: ErrorData) => void;
type OnSaveSuccess = (identityProviders: IdentityProviders) => void;
type OnSaveError = (error: ErrorData) => void;

function fetch (onSuccess: OnFetchSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'getIdentityProviders',
    {},
    (data) => onSuccess(IdentityProviders.fromJS(data)),
    onError
  );
}

function save (identityProviders: IdentityProviders, onSuccess: OnSaveSuccess, onError: OnSaveError): void {
  ConnectionSupport.post(
    'saveIdentityProviders',
    identityProviders,
    (data) => onSuccess(IdentityProviders.fromJS(data)),
    onError
  );
}

const IdentityProvidersConnection = {
  fetch,
  save
};

export default IdentityProvidersConnection;
